import { createFileRoute } from '@tanstack/react-router';

import { ApplicationTab } from '@/features/deals';

export const Route = createFileRoute('/_app/deals/$dealId/application')({
  component: function Tab() {
    const { dealId } = Route.useParams();
    return <ApplicationTab dealId={dealId} />;
  },
});
